export const PARAMS = {
  FROM_IDENTIFIER: 'from-identifier',
  FROM_DRAFT_ID: 'from-draft',
  PROMPT_TO_SELECT_DRAFT: 'prompt-for-draft',
};
